/* Shrine can split a variant into paid and free lines after a quantity change.
 * Keep its native cart requests, stock checks and live regions. Only discard a
 * quantity-limit message when the returned DOM confirms the full requested
 * variant quantity. No network requests or automatic cart additions. */
(() => {
  const pending = new Map();
  const inputsFor = (scope, variant) => Array.from(scope.querySelectorAll('input[data-quantity-variant-id]'))
    .filter(input => input.dataset.quantityVariantId === variant);

  document.addEventListener('change', event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.dataset.quantityVariantId) return;
    const scope = input.closest('cart-drawer-items, cart-items');
    const requested = Number(input.value);
    if (!scope || !Number.isInteger(requested) || requested < 1) return;
    const variant = input.dataset.quantityVariantId;
    const previousTotal = inputsFor(scope, variant)
      .reduce((total, element) => total + Number(element.getAttribute('value')), 0);
    pending.set(`${scope.localName}:${input.dataset.index}`, {
      variant,
      expected: previousTotal - Number(input.getAttribute('value')) + requested,
      created: Date.now()
    });
  }, true);

  for (const name of ['cart-items', 'cart-drawer-items']) {
    customElements.whenDefined(name).then(() => {
      const prototype = customElements.get(name).prototype;
      if (Object.prototype.hasOwnProperty.call(prototype, 'pgQuantityGuard')) return;
      const original = prototype.updateLiveRegions;
      if (typeof original !== 'function') return;
      Object.defineProperty(prototype, 'pgQuantityGuard', {value: true});
      prototype.updateLiveRegions = function (line, message) {
        const key = `${this.localName}:${line}`;
        const check = pending.get(key);
        const parts = window.cartStrings?.quantityError?.split('[quantity]');
        const isQuantityMessage = typeof message === 'string' && parts?.length === 2
          && message.startsWith(parts[0]) && message.endsWith(parts[1]);
        if (check && Date.now() - check.created < 30000 && isQuantityMessage) {
          const actual = inputsFor(this, check.variant)
            .reduce((total, input) => total + Number(input.getAttribute('value')), 0);
          if (actual === check.expected) message = '';
        }
        pending.delete(key);
        return original.call(this, line, message);
      };
    });
  }
})();
